import { render, staticRenderFns } from "./ResultsViews.vue?vue&type=template&id=7a9816c9&"
import script from "./ResultsViews.vue?vue&type=script&lang=js&"
export * from "./ResultsViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports